import React from "react"

function IconNotes({ color = "currentColor", color2, fontSize, height, ...props }) {
  return (
    <svg
      fill={color}
      fuze-icon="notes"
      viewBox="0 0 24 24"
      style={{ height: height || fontSize }}
      originalclass="fz-icon fz-icon-notes"
      {...props}
    >
      <path
        d="M19.09 2.945c.603 0 1.092.489 1.092 1.091v15.491a1.09 1.09 0 0 1-1.091 1.091H4.909a1.09 1.09 0 0 1-1.09-1.09V4.035c0-.602.488-1.09 1.09-1.09h14.182zm-.217 1.31H5.127v15.053h8.63a.873.873 0 0 1-.012-.142v-4.439c0-.301.245-.545.546-.545h4.438c.05 0 .098.004.145.012l-.001-9.94zm0 11.89-3.163 3.162 3.163.001v-3.164zm-1.197-.655h-2.621v2.621l2.621-2.621zm-5.13-5.78a.655.655 0 0 1 .106 1.3l-.107.008H7.091a.655.655 0 0 1-.106-1.3l.106-.009h5.454zm2.181-3.274a.655.655 0 0 1 .106 1.3l-.106.01H7.091a.655.655 0 0 1-.106-1.301l.106-.009h7.636z"
        fill={color}
        fillRule="evenodd"
        style={{ height: height || fontSize }}
        originalclass="__primary"
      />
    </svg>
  )
}

export default IconNotes
